<template>
  <layout-side-menu-content>
    <settings-caption>
      サイト設定
    </settings-caption>

    <form-component />
    <button-update />
  </layout-side-menu-content>
</template>

<script>
import LayoutSideMenuContent from '@/lib/Layout/SideMenuContent'
import FormComponent from './FormComponent/index'
import SettingsCaption from '@/components/Settings/Caption'
import ButtonUpdate from './ButtonUpdate'

export default {
  components: {
    LayoutSideMenuContent,
    FormComponent,
    SettingsCaption,
    ButtonUpdate
  }
}
</script>
